import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Advertising from '../entities/friendlyLink'
import Cascader from '../entities/cascader'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface AdvertisingState extends ListState<Advertising> {
    editAdvertising: Advertising;
    cascaders: any;
}
class AdvertisingModule extends ListModule<AdvertisingState, any, Advertising>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        cascaders: new Array<Cascader>(),
        list: new Array<Advertising>(),
        loading: false,
        editAdvertising: new Advertising(),
    }
    actions = {
        async getCascader(context: ActionContext<AdvertisingState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetBehindCascaderList', { params: payload.data });
            context.state.cascaders = reponse.data.result as Array<Cascader>;
        },
        async getAll(context: ActionContext<AdvertisingState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Advertising/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Advertising>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<AdvertisingState, any>, payload: any) {
            await Ajax.post('/api/services/app/Advertising/Create', payload.data);
        },
        async update(context: ActionContext<AdvertisingState, any>, payload: any) {
            await Ajax.put('/api/services/app/Advertising/Update', payload.data);
        },
        async delete(context: ActionContext<AdvertisingState, any>, payload: any) {
            await Ajax.delete('/api/services/app/Advertising/Delete?Id=' + payload.data.id);
        },
        async get(context: ActionContext<AdvertisingState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Advertising/Get?Id=' + payload.data.id);
            context.state.editAdvertising = reponse.data.result as Advertising;
        }
    };
    mutations = {
        setCurrentPage(state: AdvertisingState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: AdvertisingState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: AdvertisingState, advertising: Advertising) {
            state.editAdvertising = advertising;
        }
    }
}
const advertisingModule = new AdvertisingModule();
export default advertisingModule;